import React from 'react';
import ContactInfo from 'components/molecules/ContactInfo';
import { Box, Container, Stack, Typography } from '@mui/material';
import { useTrackPageEffect } from 'hooks/services/useTrackPageEffect';
import { AuditEvent } from 'types/track/AuditEventType';

export const ContactUs = () => {
   useTrackPageEffect({
        eventType: AuditEvent.MemberPortalViewContactUs,
    });
    return (
        <Container component="main" id="contact-us-page" data-testid="contact-us-page" sx={{
            marginTop: 4,
        }}>
            <Stack spacing={2}>
                <Box pb={4}>
                    <ContactInfo />
                </Box>
            </Stack>
        </Container>
    );
};

export default ContactUs;
